import { applyMiddleware, compose, createStore } from 'redux'

import { browserHistory } from 'react-router'
import { routerMiddleware } from 'react-router-redux'

import { createLogger } from 'redux-logger'

import reducers from './reducers'

import analyticsMiddleware from 'Global/Middlewares/analytics'
import apiMiddleware from 'Global/Middlewares/api'
import authMiddleware from 'Global/Middlewares/auth'
import confirmationMiddleware from 'Global/Middlewares/confirmation'
import globalMessageMiddleware from 'Global/Middlewares/globalMessage'
import localStorageMiddleware from 'Global/Middlewares/localStorage'
import saveAsMiddleware from 'Global/Middlewares/saveAs'

const middlewares = [
  createLogger(),
  routerMiddleware(browserHistory),
  analyticsMiddleware,
  saveAsMiddleware,
  confirmationMiddleware,
  apiMiddleware,
  globalMessageMiddleware,
  localStorageMiddleware,
  authMiddleware,
]

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export default createStore(reducers, composeEnhancers(applyMiddleware(...middlewares)))
